define('constants/signupNumberTypeSelectionConstants',[], function() {
    return {
        'local': 1,
        'tollFree': 2,
        'port': 3,
    };
});
